<template>
  <div class="cell">
    <div class="label">{{ label }}：</div>
    <div class="value">{{ value ? value : '--' }}</div>
  </div>
</template>

<script>
export default {
  name: 'TheCell',
  props: ['label', 'value']
}
</script>

<style lang="scss" scoped>
.cell {
  width: 200px;
  margin-bottom: 16px;
  display: inline-flex;
  flex-flow: column;

  .label, .value {
    width: 200px;
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFangSC;
    font-weight: 400;
    line-height: 14px;
  }

  .label {
    color: #999999;
    margin-bottom: 8px;
  }

  .value {
    color: #333333;
    line-height: 14px;
  }
}
</style>
